var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-immunizations.f55bffd7.png","uri@2x": __webpack_public_path__ + "icon-immunizations.1538b463.png","uri@3x": __webpack_public_path__ + "icon-immunizations.a3c08948.png",
    width: 20,
    height: 20
});